// 升级公告配置
export const announcementConfig = {
  // 是否启用公告
  enabled: true,

  // 公告标题
  title: 'PageSmooth 5.0 全新升级',

  // 公告内容（一句话）
  message: '全新升级，更快、更准、更专业的证件翻译体验',

  // 公告链接（点击跳转到详情页面）
  link: null,

  // 关闭后多久不再显示：'session' | 'day' | 'permanent' | timestamp(毫秒)
  dismissDuration: 15 * 24 * 60 * 60 * 1000, // 15天

  // 永久隐藏的截止日期（在此日期之后永久不再显示），格式：'YYYY-MM-DD'
  // 设置为 null 则不启用
  permanentHideAfter: '2026-05-30',

  // 显示优先级（数字越大优先级越高）
  priority: 1
};
